import client from '../../providers/fetchClient'

export const getAllGenders = () => client.get('/v3/genders')
